module.exports = __webpack_public_path__ + "img/push.ac51ee65.gif";